/* unplugin-vue-components disabled */import { render } from "./AccountButton.vue?vue&type=template&id=016f9514&ts=true"
import script from "./AccountButton.vue?vue&type=script&lang=ts"
export * from "./AccountButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__